// 2025/3/21
// shopは互換性のために残している。
// 現在使われているのは store + course

export default function getFormParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const shopIdsStr = searchParams.get("shop");
  const shopIds = shopIdsStr?.split(",").map((shopIdStr) => Number.parseInt(shopIdStr));
  const storeIdsStr = searchParams.get("store");
  const storeIds = storeIdsStr?.split(",").map((storeIdStr) => Number.parseInt(storeIdStr));
  const courseIdsStr = searchParams.get("course");
  const courseIds = courseIdsStr?.split(",").map((courseIdStr) => Number.parseInt(courseIdStr));
  const reservationStartTimeStr = searchParams.get("startAt");
  const reservationStartTime = reservationStartTimeStr ? Number.parseInt(reservationStartTimeStr) : undefined;

  if (shopIds && !courseIds) {
    return { storeIds: shopIds, courseIds: [], reservationStartTime };
  }

  return { storeIds, courseIds, reservationStartTime };
}
